import { render, staticRenderFns } from "./ForwardRecord.vue?vue&type=template&id=08256b4e&scoped=true"
import script from "./ForwardRecord.vue?vue&type=script&lang=js"
export * from "./ForwardRecord.vue?vue&type=script&lang=js"
import style0 from "./ForwardRecord.vue?vue&type=style&index=0&id=08256b4e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08256b4e",
  null
  
)

export default component.exports